// src/firebase/firebase-config.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyA91bUy1aOfY7GMUToo9w4wq46YrrfaEw4",
  authDomain: "crime-watch-50fbd.firebaseapp.com",
  projectId: "crime-watch-50fbd",
  storageBucket: "crime-watch-50fbd.firebasestorage.app",
  messagingSenderId: "190208255092",
  appId: "1:190208255092:web:ade080e3dd6fef91955d21"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export auth and db
export const auth = getAuth(app);
export const db = getFirestore(app);

// Optional: export app if needed elsewhere
export default app;

